/**
 * Honduran lempira.
 */
export var HNL = {
  code: 'HNL',
  base: 10,
  exponent: 2
};